import { surgeReachNote } from '../format';

import SurgeDialog from './SurgeDialog';

type Props = {
  scope: 'client' | 'shift';
  /**
   * Shifts on the job — only meaningful for the 'shift' scope. Money is about
   * to move, so this step names what the raise will reach rather than promising
   * "this shift only", which was the opposite of what happens (Decision 2).
   */
  shiftsCount?: number;
  saving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

// The design's copy (Figma 40573:194256), with the agreed text fixes: "Update
// surge pay", not "Surge pay override" — nothing is being overridden — and
// "Continue & save" as the action. The 'shift' scope's sentence comes from
// `surgeReachNote` (Decision 2).
const CLIENT_COPY =
  'This applies to shifts posted from now on. Shifts already posted keep their current surge schedule.';

/** The confirmation before a surge schedule is saved (GRAVY-10443). */
const ConfirmSurgeDialog = ({
  scope,
  shiftsCount,
  saving,
  onCancel,
  onConfirm,
}: Props) => (
  <SurgeDialog
    size="sm"
    testId="surgeConfirm"
    title="Update surge pay"
    onClose={onCancel}
  >
    <p className="paysurge-body">
      {scope === 'client' ? CLIENT_COPY : surgeReachNote(shiftsCount ?? 1)}
    </p>
    <div className="paysurge-actions">
      <button
        type="button"
        className="paysurge-btn is-outline"
        onClick={onCancel}
      >
        Cancel
      </button>
      <button
        type="button"
        className="paysurge-btn is-primary"
        data-testid="surgeConfirmSave"
        disabled={saving}
        onClick={onConfirm}
      >
        {saving ? 'Saving…' : 'Continue & save'}
      </button>
    </div>
  </SurgeDialog>
);

export default ConfirmSurgeDialog;
